<template>
<div
  style="padding: 2.5em;"
>
  <v-tabs
    dark
    pa-6
    background-color="pink accent-4"
      class="elevation-4"
      centered
      grow="grow"
    slider-color="#fff"
  >

    <v-tab>Emotes</v-tab>
    <v-tab>Chibi Art</v-tab>
    <v-tab>
      <font-awesome-icon
            :icon="['fab', 'twitch']"
            size="2x"
          ></font-awesome-icon>
      &nbsp;Chat
    </v-tab>

  <v-tabs-slider></v-tabs-slider>
  <v-tab-item>
  <v-layout 
  column
  xs1
  >
    <v-flex>
      <v-card tile>
        <v-container grid-list-xs>
          <v-layout wrap xs4>
            <v-flex
              v-for="emote in emotes"
              :key="emote"
              xs2
              d-flex
              child-flex

            >
              <v-card tile class="d-flex">
                <v-img
                  :src="emote.src"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
  </v-tab-item>

<v-tab-item>
    <v-layout 
  column
  >
    <v-flex 
      xs12 
      sm12 
      >
      <v-card tile>
        <v-container grid-list-sm fluid>
          <v-layout wrap>
            <v-flex
              v-for="chibi in chibis"
              :key="chibi"
              xs4
              d-flex
              child-flex
            >
              <v-card flat tile class="d-flex">
                <v-title></v-title>
                <v-img
                  :src="chibi.src"
                  aspect-ratio=".6"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
  </v-tab-item>
  </v-tabs>
</div>
</template>

<script>
export default {
  data() {
    return {
      emotes: [
        {
          src: require('../assets/emotes/attackemotelarge.png')
        },
        {
          src: require('../assets/emotes/brittloveemote.png')
        },
        {
          src: require('../assets/emotes/brittchibi.png')
        },
        {
          src: require('../assets/emotes/chibiemote.png')
        },
        {
          src: require('../assets/emotes/bunquackemotelarge.png')
        },
        {
          src: require('../assets/emotes/bunpooemotelarge.png')
        },
        {
          src: require('../assets/emotes/bunhopemotelarge.png')
        },
        {
          src: require('../assets/emotes/cutegrillemote.png')
        },
        {
          src: require('../assets/emotes/feelsbatmanemotebig.png')
        },
        {
          src: require('../assets/emotes/ensoheartemotelarge.png')
        },
        {
          src: require('../assets/emotes/kittyvremotelarge.png')
        },
        {
          src: require('../assets/emotes/isabellexmasemotelarge.png')
        },
        {
          src: require('../assets/emotes/gooseemotelarge.png')
        },
        {
          src: require('../assets/emotes/goldshieldlarge.png')
        },
        {
          src: require('../assets/emotes/shieldcoloredlarge.png')
        },
        {
          src: require('../assets/emotes/silversieldlarge.png')
        },
        {
          src: require('../assets/emotes/gonzoemotelarge.png')
        },
        {
          src: require('../assets/emotes/lovenarwalemote.png')
        },
        {
          src: require('../assets/emotes/nerdynarwalemote.png')
        },
        {
          src: require('../assets/emotes/rosiefoxheartemotelarge.png')
        },
        {
          src: require('../assets/emotes/rosiefoxhelmetemotelarge.png')
        },
        {
          src: require('../assets/emotes/rosiefoxhypeemotelarge.png')
        },
        {
          src: require('../assets/emotes/subhypeemote.png')
        },
        {
          src: require('../assets/emotes/treylohatchetemote.png')
        },
        {
          src: require('../assets/emotes/treyloripemotelarge.png')
        },
        {
          src: require('../assets/emotes/treylorollemotelarge.png')
        },
        {
          src: require('../assets/emotes/unicornhypeemotelarge.png')
        },
        {
          src: require('../assets/emotes/wolfswordlogobluengreen.png')
        },
        {
          src: require('../assets/emotes/zeldaemotelarge.png')
        },
        {
          src: require('../assets/emotes/yassqueenemote.png')
        },
      ],
      chibis: [
        {
          src: require('../assets/emotes/brittchibi.png')
        },
        {
          src: require('../assets/emotes/blazinchibi.png')
        },
        {
          src: require('../assets/emotes/bubbleschibi.png')
        },
        {
          src: require('../assets/emotes/gavinchibi.png')
        },
        {
          src: require('../assets/emotes/hookschibi.png')
        },
        {
          src: require('../assets/emotes/icecreamwaifuprizezach.png')
        },
        {
          src: require('../assets/emotes/judgechibi.png')
        },
        {
          src: require('../assets/emotes/kinnuechibi.png')
        },
        {
          src: require('../assets/emotes/slochibi.png')
        },
      ]
    }
  }
}
</script>
